import { defineChatPlace } from '../../chat/panel';

/** The chat docked beside a manual dashboard. */
export const boardChat = defineChatPlace({
  id: 'board',
  place: 'docked',
  results: 'inline',
  features: {
    sqlApproval: true,
    voiceCalls: false,
    addToDashboard: true,
    copy: true,
    contextChips: true,
  },
  welcome: { title: '', subtitle: 'Ask about the cohorts, segments and stages on this board.' },
  // Phrased as questions the board cannot answer by being looked at — a
  // re-cut, a comparison, a cause.
  starters: [
    'Which carrier is dragging placement down?',
    'Did placement fall in August, or is that cohort just young?',
    'Compare placement rate by channel group',
    'Where do we lose the most premium between stages?',
  ],
  placeholder: 'Ask about this board…',
});
